import CustomButton from "../../../../../components/custom/button";
import AddressListSkeleton from "../../../profilePage/skelitons/ManageAddressListSkeleton";
import { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { getAddressListAsync } from "../../../../../../app/slices/addressSlice/ProfileSlice";
import CustomDialog from "../../../../../components/custom/dialog";
import { AddOrEditAddress } from "../../../profilePage/components/address/AddOrEditAddress";
import { DeleteAddress } from "../../../profilePage/components/address/DeleteAddress";
import useFetchCurrentLocation from "./FetchCurrentLocationAndPlace";
import { useMediaQuery } from "@mui/material";
import { EmptyAddressList } from "../../../profilePage/components/emptyStates/EmptyStatesProfile";
import {
  setInfoButtonDisabled,
  setStepperActiveMenu,
  selectedAddressId,
  getAddressChangeAsync,
} from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import {
  setAddressType,
  setCheckoutAddressId,
} from "../../../../../../app/slices/common/locationSlice/locationSlice";
import { LocationConfirmationPrompt } from "../../../../public/locationSearchbar/LocationConfirmationPromt";
import { LongDistancePrompt } from "../../../../public/locationSearchbar/LongDistancePrompt";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";

export const isLongDistanceEligibleForAmount = (amount: number) =>
  Number(amount || 0) >= 300;

// Props for DeliverAddress. Keep props optional so existing usages remain working.
interface DeliverAddressProps {
  fromCustomOrder?: boolean;
  isLongDistance?: boolean;
  // Allow handlers with any signature (zero or more args) so callers with
  // different signatures (e.g. (add: any) => void) are accepted.
  handleEnquirySubmit?: (...args: any[]) => void;
  isPopup?: boolean;
  onClose?: () => void;
}

export const DeliverAddress = ({
  fromCustomOrder = false,
  isLongDistance = false,
  handleEnquirySubmit,
  isPopup = false,
  onClose,
}: DeliverAddressProps) => {
  const isMobileScreen = useMediaQuery("(max-width: 765px)");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useAppDispatch();
  const { addressList }: any = useAppSelector((state) => state?.AddressState);
  const { isValidUser }: any = useAppSelector((state) => state.ProfileState);
  const [editDeleteId, setEditDeleteId] = useState("");
  const { addTocart } = useAppSelector((state) => state.CartState);
  const location = useAppSelector((state) => state.locationState);

  const itemTotal = Number(addTocart?.billingData?.total_without_delivery || 0);
  const isCartEligibleForLongDistance =
    isLongDistanceEligibleForAmount(itemTotal);

  const [modalType, setModalType] = useState("");
  const [modalOptions, setModalOptions] = useState<any>(null);
  const [addressId, setAddressId] = useState("");
  const [selectedAddressType, setSelectedAddressType] = useState("");

  const [selectedAddress, setSelectedAddress] = useState("home");
  const [lat, setLat] = useState<any>(null);
  const [lng, setLng] = useState<any>(null);
  const [selectedCheckoutAddress, setSelectedCheckoutAddress] = useState("");
  const [tempSelectedAddress, setTempSelectedAddress] = useState<any>(null);

  const { place } = useFetchCurrentLocation();
  // const isInputFilled = selectedAddress.trim() !== "";
  const isInputFilled =
    addressId !== "" && addressId !== undefined && addressId !== null;
  const checkoutAddressId = useAppSelector(
    (state) => state.locationState.setCheckoutAddressId,
  );
  const storedSelectedAddressId = useAppSelector(
    (state) => state.CheckoutState.selectedAddressId,
  );

  useEffect(() => {
    if (checkoutAddressId) {
      setAddressId(checkoutAddressId);
      dispatch(selectedAddressId(checkoutAddressId));
    } else if (storedSelectedAddressId) {
      setAddressId(storedSelectedAddressId);
    } else {
      setAddressId(location?.locationGot?.address_id);
      dispatch(selectedAddressId(location?.locationGot?.address_id));
    }
  }, [
    dispatch,
    location?.locationGot?.address_id,
    checkoutAddressId,
    storedSelectedAddressId,
  ]);

  // useEffect(() => {
  //   setAddressId(location?.locationGot?.address_id);
  //   dispatch(selectedAddressId(location?.locationGot?.address_id));
  // }, [dispatch, location?.locationGot?.address_id]);

  useEffect(() => {
    dispatch(setInfoButtonDisabled(!isInputFilled && isValidUser));
  }, [isInputFilled, dispatch]);
  useEffect(() => {
    dispatch(getAddressListAsync());
  }, []);
  const onModalSelection = (type: string, item?: any, options?: any) => {
    if (type !== "add") {
      setEditDeleteId(item?.id);
    }
    setSelectedAddressType(item?.address_type);

    setModalOptions(options);
    setModalType(type);
  };
  const modalClose = () => {
    setModalType("");
    setModalOptions(null);
    setEditDeleteId("");
    //setAddressId("");
  };
  const promptClose = () => {
    setModalType("");
    setModalOptions(null);
    setEditDeleteId("");
  };
  const onModalCloseCallback = (event: any) => {};
  // const onNextClick = (active: any) => {
  //   const payload: any = {
  //     address_id: Number(addressId),
  //   };
  //   dispatch(getAddressChangeAsync(payload)).then((response: any) => {
  //     if (response?.payload?.data?.proceed) {
  //       dispatch(setStepperActiveMenu(active));
  //     } else {
  //       onModalSelection("locationConfirmation");
  //     }
  //   });
  // };
  const onNextClick = (active: any) => {
    console.log("Continue clicked", addressId);
    const payload = {
      address_id: Number(addressId),
    };

    dispatch(getAddressChangeAsync(payload)).then((response: any) => {
      if (response?.payload?.data?.proceed) {
        if (isPopup) {
          onClose?.(); // close popup
          return;
        }

        dispatch(setStepperActiveMenu(active));
      } else {
        const modalOptions = response?.payload?.data?.message && {
          message: response?.payload?.data?.message,
        };
        onModalSelection("locationConfirmation", null, modalOptions);
      }
    });
  };
  const handleRadioChange = (event: any, value: any) => {
    setSelectedCheckoutAddress(value);
    const payload: any = {
      address_id: Number(value.id),
    };
    dispatch(getAddressChangeAsync(payload)).then((response: any) => {
      // Check long_distance first - takes priority
      if (response?.payload?.data?.deliverable === false) {
        if (!isCartEligibleForLongDistance) {
          dispatch(
            showSnackbar({
              message: "Add ₹300 or more to your cart to unlock delivery.",
              severity: "error",
              autoHide: 2600,
            }),
          );
          return;
        }

        // Store the address temporarily and show long distance popup
        setTempSelectedAddress(value);
        setModalType("longDistanceConfirmation");
      } else if (
        response?.payload?.data?.delivery_fee_change &&
        response?.payload?.data?.proceed
      ) {
        const modalOptions = response?.payload?.data?.message && {
          message: response?.payload?.data?.message,
          isDeliveryChargeChangeOnly: true,
        };
        onModalSelection("locationConfirmation", null, modalOptions);
      } else if (response?.payload?.data?.proceed) {
        setSelectedAddress(value?.address_type); // Update the selected address
        setLat(Number(value.latitude));
        setLng(Number(value.longitude));
        dispatch(setAddressType(value?.address_type));
        setAddressId(value?.id);
        dispatch(selectedAddressId(value?.id));
        dispatch(setCheckoutAddressId(""));
        // onCloseModal();
      } else {
        const modalOptions = response?.payload?.data?.message && {
          message: response?.payload?.data?.message,
        };
        onModalSelection("locationConfirmation", null, modalOptions);
      }
    });
  };

  const handleLongDistanceProceed = () => {
    if (tempSelectedAddress) {
      setSelectedAddress(tempSelectedAddress?.address_type);
      setLat(Number(tempSelectedAddress.latitude));
      setLng(Number(tempSelectedAddress.longitude));
      dispatch(setAddressType(tempSelectedAddress?.address_type));
      setAddressId(tempSelectedAddress?.id);
      dispatch(selectedAddressId(tempSelectedAddress?.id));
      setSelectedCheckoutAddress(tempSelectedAddress);
      setTempSelectedAddress(null);
    }
  };

  if (isMobileScreen && !isPopup) {
    return null;
  }

  return (
    <div
      className={fromCustomOrder ? "px-4 py-3" : ""}
      style={
        isPopup && isMobileScreen
          ? {
              maxWidth: "360px",
              width: "100%",
              margin: "0 auto",
              padding: "16px",
            }
          : {}
      }
    >
      <div className="row mt-3">
        <div className="col-md-12 px-0">
          {!fromCustomOrder && !isPopup && <h2>Select a delivery address</h2>}
          <div className="card mb-3 card-navya">
            <div className="card-body">
              <div className="row justify-content-between align-items-start">
                <div className="pe-3 col-auto">
                  <HomeOutlinedIcon color="secondary" fontSize="large" />
                </div>
                <div
                  style={{
                    fontFamily: "Albert Sans, sans-serif",
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: "400",
                  }}
                  className="col"
                >
                  <p>
                    <b>Add New Address</b>
                  </p>
                  <p className="mb-2">You seem to be in a new Address</p>
                  {/* <p className="text-semi">{place && place}</p> */}
                  <div className="tf-btn radius-3 justify-content-center px-0">
                    <CustomButton
                      size="large"
                      endIcon={<AddIcon />}
                      fullWidth
                      name="Add New Address"
                      onClick={() => onModalSelection("add")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-account-content account-order">
        <div className="row mb-2"></div>
        {addressList?.loader ? (
          <AddressListSkeleton />
        ) : (
          <>
            <div className="row padd-adj">
              {addressList?.data?.length > 0 ? (
                addressList?.data?.map((item: any, index: any) => {
                  return (
                    // <div className="col-md-6 ps-0 " key={index}>
                    <div
                      className={
                        isPopup && isMobileScreen ? "col-12" : "col-md-6 ps-0"
                      }
                      key={index}
                      style={
                        isPopup && isMobileScreen
                          ? {
                              display: "flex",
                              justifyContent: "center",
                              marginBottom: "16px",
                            }
                          : {}
                      }
                    >
                      <div
                        onClick={(e: any) => handleRadioChange(e, item)}
                        className="card mb-3 card-navya"
                        // style={{
                        //   border:
                        //     addressId === item.id
                        //       ? "1px solid rgb(252, 87, 50)"
                        //       : "",
                        //   cursor: "pointer",
                        // }}
                        style={{
                          width: isPopup && isMobileScreen ? "100%" : "",
                          maxWidth: isPopup && isMobileScreen ? "340px" : "",
                          border:
                            addressId === item.id
                              ? "1px solid rgb(252, 87, 50)"
                              : editDeleteId !== item.id
                                ? "1px solid #91989b"
                                : "",
                          cursor: "pointer",

                          borderRadius: "10px",
                        }}
                      >
                        <div
                          className="card-body"
                          style={{
                            fontFamily: "Albert Sans, sans-serif",
                            fontSize: "14px",
                            lineHeight: "22px",
                            fontWeight: "400",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-2">
                              <div className="">
                                <div className="pe-3">
                                  <div>
                                    <p
                                      style={{
                                        opacity:
                                          addressId !== item.id &&
                                          editDeleteId !== item.id
                                            ? 0.5
                                            : 1,
                                      }}
                                    >
                                      {item?.address_type === "work" && (
                                        <WorkOutlineOutlinedIcon
                                          color="secondary"
                                          fontSize="small"
                                        />
                                      )}
                                      {item?.address_type === "other" && (
                                        <WorkOutlineOutlinedIcon
                                          color="secondary"
                                          fontSize="small"
                                        />
                                      )}
                                      {item?.address_type === "home" && (
                                        <HomeOutlinedIcon
                                          color="secondary"
                                          fontSize="small"
                                        />
                                      )}
                                      {/* &nbsp; &nbsp; */}
                                      {/* <b>{item?.address_type?.toUpperCase()}</b> */}
                                    </p>
                                    {/* <p className="m-2 ">
                                      {`${item?.flat_no}, ${item?.landmark}`}
                                    </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-10">
                              <div
                                style={{
                                  opacity:
                                    addressId !== item.id &&
                                    editDeleteId !== item.id
                                      ? 0.5
                                      : 1,
                                }}
                              >
                                <p>
                                  <b>{item?.address_type?.toUpperCase()}</b>
                                </p>
                                <p className="mb-2">
                                  {`${item?.flat_no}, ${item?.landmark}`}
                                </p>
                              </div>
                              {/* <div className="row">
                                <div
                                  className="col-6"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <CustomButton
                                    name="Edit"
                                    fullWidth
                                    onClick={() =>
                                      onModalSelection("edit", item)
                                    }
                                  />
                                </div>{" "}
                                <div
                                  className="col-6"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <CustomButton
                                    className="ml-2"
                                    fullWidth
                                    color="secondary"
                                    name="Delete"
                                    onClick={() =>
                                      onModalSelection("delete", item)
                                    }
                                  />
                                </div>
                              </div> */}
                              {/* <div
                                className="d-flex align-items-center mt-2"
                                style={{ gap: "16px" }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  className="btn-prime"
                                  onClick={() => onModalSelection("edit", item)}
                                >
                                  Edit{" "}
                                </div>

                                <div
                                  // style={{ marginLeft: "10px" }}
                                  className="btn-second "
                                  onClick={() =>
                                    onModalSelection("delete", item)
                                  }
                                >
                                  Delete{" "}
                                </div>
                              </div> */}
                              <div
                                className="d-flex align-items-center mt-2"
                                style={{ gap: "16px" }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <span
                                  style={{
                                    minWidth: "45px",
                                    height: "38px",
                                    width: "max-content",
                                    border: "1px solid #000000",
                                    backgroundColor: "var(--main)",
                                    borderRadius: "3px",
                                    padding: "7px 15px",
                                    color: "#fff",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    onModalSelection("edit", item);
                                    e.preventDefault();
                                  }}
                                >
                                  Edit
                                </span>

                                <span
                                  style={{
                                    minWidth: "45px",
                                    height: "38px",
                                    width: "max-content",
                                    border:
                                      "1px solid rgba(134, 134, 134, 0.12)",
                                    borderRadius: "3px",
                                    padding: "7px 15px",
                                    background: "#fff",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor:
                                      addressId === item.id
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity: addressId === item.id ? 0.5 : 1,
                                  }}
                                  onClick={(e) => {
                                    if (addressId === item.id) {
                                      return;
                                    }
                                    onModalSelection("delete", item);
                                    e.preventDefault();
                                  }}
                                >
                                  Delete
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <EmptyAddressList />
              )}
            </div>{" "}
            <CustomButton
              endIcon={<ArrowForwardIcon />}
              className="ml-2"
              name={
                fromCustomOrder ? "Confirm address and proceed" : "Continue"
              }
              onClick={() => {
                if (fromCustomOrder) {
                  // If used from custom order flow, call the parent handler to submit enquiry
                  handleEnquirySubmit?.(addressId);
                } else {
                  // For long distance, skip delivery info and go to payment
                  const nextStep = isLongDistance ? "pay" : "deliveryInfo";
                  onNextClick(nextStep);
                }
              }}
              disabled={!isInputFilled}
            />
          </>
        )}
      </div>
      <CustomDialog
        component={
          <AddOrEditAddress
            addressId={editDeleteId}
            modalClose={modalClose}
            modalType={modalType}
            isLongDistance={isLongDistance}
          />
        }
        title="Edit"
        openDialog={modalType === "edit"}
        handleCloseDialog={modalClose}
        modalPlace="right"
      />
      <CustomDialog
        component={
          <AddOrEditAddress
            modalType={modalType}
            modalClose={modalClose}
            isLongDistance={isLongDistance}
          />
        }
        title="Add New Address"
        openDialog={modalType === "add"}
        handleCloseDialog={modalClose}
        modalPlace="right"
      />
      <CustomDialog
        component={
          <DeleteAddress
            type={selectedAddressType}
            modalClose={modalClose}
            addressId={editDeleteId}
          />
        }
        title="Delete"
        openDialog={modalType === "delete"}
        handleCloseDialog={modalClose}
      />
      <CustomDialog
        component={
          <LocationConfirmationPrompt
            address={selectedCheckoutAddress}
            onClose={promptClose}
            onModalCloseCallback={onModalCloseCallback}
            isFromCheckout={true}
            message={modalOptions?.message}
            isDeliveryChargeChangeOnly={
              modalOptions?.isDeliveryChargeChangeOnly
            }
          />
        }
        title=""
        openDialog={modalType === "locationConfirmation"}
        handleCloseDialog={promptClose}
        modalPlace="center"
      />
      <CustomDialog
        component={
          <LongDistancePrompt
            onClose={promptClose}
            onProceed={handleLongDistanceProceed}
          />
        }
        title=""
        openDialog={modalType === "longDistanceConfirmation"}
        handleCloseDialog={promptClose}
        modalPlace="center"
      />
    </div>
  );
};
